module.exports = __webpack_public_path__ + "static/plant-store-2c3aab06a57c60618b23b8d25cfed2f8.png";